import {useMutation, UseMutationResult} from "@tanstack/react-query";
import {api} from "@/features/api";
import {getAffiliateCode} from "@/utils/affiliate-code";

const useSendSignInLinkToEmail: () => UseMutationResult = () =>
  useMutation({
    mutationFn: async (email) => {
      const affiliateCode = getAffiliateCode();

      const response = await api("TRENDARO_API_URL", false).post(
        `/users:signByEmail`,
        {
          json: {
            email,
            customURL: window.location.origin,
            ...(affiliateCode ? {affiliateCode} : {}),
          },
        },
      );

      if (!response.ok) {
        const data = await response.json();

        if (data?.error?.includes(`User with email ${email} not found.`)) {
          throw new Error("Omlouváme se, teď se nelze registrovat.");
        } else {
          throw new Error(
            `HTTP ${response.status} při odesílání odkazu pro přihlášení na e-mail. (${data?.error})`,
          );
        }
      }

      return true;
    },
  });

export default useSendSignInLinkToEmail;
